import Page from "components/base/Page";
import { NavigationLink } from "components/base/base";
import { Navigate, Outlet, Route, Routes } from "react-router-dom";
import ProductionNodes from "./productionNodes";
import Suppliers from "./suppliers";
import SupplierDetail from "./suppliers/Detail";

function ProductionRoutes() {
  return (
    <Routes>
      <Route element={<Layout />}>
        <Route path="suppliers" element={<Suppliers />} />
        <Route path="suppliers/:id" element={<SupplierDetail />} />
        <Route path="production-nodes" element={<ProductionNodes />} />
        <Route path="*" element={<Navigate to="suppliers" />} />
      </Route>
    </Routes>
  );
}

const Layout = () => (
  <Page
    className="h-screen"
    leftButtons={
      <div className="flex space-x-4">
        <NavigationLink to="/production/suppliers" title="Suppliers" />
        <NavigationLink
          to="/production/production-nodes"
          title="Production Nodes"
        />
      </div>
    }
  >
    <Outlet />
  </Page>
);

export default ProductionRoutes;
